<template>
  <div class="steps">
    <span
      class="steps__color--xuhao"
      :style="{
        color: currentColor ? '#fff' : '#6D7278',
        background: currentColor,
        'border-color': currentColor,
      }"
      >01</span
    >
    <span
      class="steps__color--text"
      :style="{ color: currentColor, 'border-color': currentColor }"
      >上传</span
    >
    <span
      class="steps__color--line"
      :style="{ color: currentColor, 'border-color': currentColor }"
    ></span>
    <span
      class="steps__color--xuhao"
      :style="{
        color: currentColor ? '#fff' : '#6D7278',
        background: currentColor,
        'border-color': currentColor,
      }"
      >02</span
    >
    <span
      class="steps__color--text"
      :style="{ color: currentColor, 'border-color': currentColor }"
      >压缩</span
    >
    <span
      class="steps__color--line"
      :style="{ color: currentColor, 'border-color': currentColor }"
    ></span>
    <span
      class="steps__color--xuhao"
      :style="{
        color: currentColor ? '#fff' : '#6D7278',
        background: currentColor,
        'border-color': currentColor,
      }"
      >03</span
    >
    <span
      class="steps__color--text"
      :style="{ color: currentColor, 'border-color': currentColor }"
      >下载</span
    >
  </div>
</template>
<script>
export default {
  name: "Steps-com",
  data() {
    return {
      currentColor: "#0005a8", // '#C3D7FF'
    };
  },
};
</script>
<style lang="scss" scoped>
.steps {
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  width: 530px;
  margin: 60px auto;
  font-size: 18px;
  color: #6d7278;
  .steps__color--xuhao {
    display: inline-block;
    width: 36px;
    height: 36px;
    border-radius: 20px;
    border: 1px solid #6d7278;
    text-align: center;
    font-weight: 600;
    transition: all 0.3s;
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0;
    line-height: 36px;
    font-weight: 600;
  }
  .steps__color--text {
    transition: all 0.3s;
  }
  .steps__color {
    border-color: #38b968 !important;
    color: #38b968;
  }
  .steps__color--line {
    width: 22%;
    border-top: 1px dashed #6d7278;
    transition: all 0.3s;
  }
}
</style>
